const formulasEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/settings/key-figures/formulas` as const,
  detail: (companyId: string, formulaId: number) =>
    `/companies/${companyId}/settings/key-figures/formulas/${formulaId}` as const,
  order: (companyId: string) => `/companies/${companyId}/settings/key-figures/formulas/order` as const,
  budgetDriver: (companyId: string, formulaId: number) =>
    `/companies/${companyId}/settings/key-figures/formulas/${formulaId}/data` as const
}

export default formulasEndpoints
